import React, { Component } from 'react';

export default class NotFound extends Component {
  render() {
    return (
      <section className='not-found'>
        <h2>Not Found</h2>
        <p>Apologies, the page you were looking for isn't here.</p>
      </section>
    )
  }
}